export const CHANNEL_PARTNER = "cp"
export const GROWER = "grower"

export const YES = "yes"
export const NO = "no"

export const REGULAR_USER = "user"
export const STAFF_USER = "staff"

export const CLIENT_PROFILES = "clientProfiles"
export const ENROLLMENT_TABLE = "enrollmentTable"
export const SUPPLY_SHED_TABLE = "supplyShedTable"
export const CP_FSS_TABLE = "channelPartnerFSSTable"
export const FSS_INDIVIUAL = "fss"

export const OPEN = "open"
export const REQUESTED = "requested"
export const REQUESTED_PENDING = "requested_pending"
export const AVAILABLE = "available"
export const CONFIRMED = "confirmed"
export const LOCKED_FOR_PAYMENT = "locked_for_payment"
export const PENDING_VERIFICATION = "pending_verification"
export const DISQUALIFIED = "disqualified"

// FieldSupplySummary.Status, in lifecycle order
export const FSS_STATUS_LABELS = {
  [OPEN]: "Open",
  [REQUESTED_PENDING]: "Requested (Pending)",
  [REQUESTED]: "Requested",
  [AVAILABLE]: "Available",
  [PENDING_VERIFICATION]: "Pending Verification",
  [CONFIRMED]: "Confirmed",
  [LOCKED_FOR_PAYMENT]: "Locked for Payment",
  [DISQUALIFIED]: "Disqualified",
}

// a field with no FieldSupplySummary in the year still needs a filterable value, otherwise it
// could never be found through a status filter
export const NO_SUPPLY_SUMMARY = "No Supply Summary"
export const NO_SUPPLY_SUMMARY_STATUS = "no_supply_summary"

export const REQUESTED_DELTA = `${REQUESTED}_delta`
export const CONFIRMED_DELTA = `${CONFIRMED}_delta`

export const STATUS_IS_STATIC = false
export const STATUS_CHANGE_PENDING = true

export const NOT_READY_YET = "not ready yet"
export const READY_FOR_GENERATION = "ready for generation"
export const CONTRACT_GENERATED = "contract generated"
export const AWAITING_REVIEW = "awaiting review"
export const CONTRACT_VOIDED = "contract voided"
export const CHANGES_REQUESTED = "changes requested"
export const APPROVED = "approved"
export const CONTRACT_COMPLETED = "contract completed"

export const ADD_PROFILE = 0
export const REMOVE_PROFILE = 1
export const UPDATE_PROFILE = 2
export const SWAP_PROFILE = 3
export const CREATE_PROFILE = 4

// FieldSupplySummary.program_type_desired / EAOrderRollup.credit_tier –– 45z supply is tracked
// under the ci45z credit tier, everything else is scope 3
export const CI45Z = "ci45z"
export const SCOPE3 = "scope3"

export const ANY_HARVEST_TYPE = "any"
export const SILAGE = "silage"

export const BLANK_GROUP_DATA = {
  enrollment: {},
  cp_profiles: [],
  grower_profiles: [],
  landowner_profiles: [],
}

export const FSS_YES_NO_CLASS_MAP = {}
export const BLANK_ACREAGE_VALUES = {}

for (const status of [OPEN, AVAILABLE, REQUESTED_PENDING, REQUESTED, CONFIRMED, LOCKED_FOR_PAYMENT]) {
  FSS_YES_NO_CLASS_MAP[status] = {}
  BLANK_ACREAGE_VALUES[status] = {}

  for (const pendingStatus of [STATUS_IS_STATIC, STATUS_CHANGE_PENDING]) {
    FSS_YES_NO_CLASS_MAP[status][pendingStatus] = {}
    BLANK_ACREAGE_VALUES[status][pendingStatus] = {}

    for (const userPerms of [REGULAR_USER, STAFF_USER]) {
      FSS_YES_NO_CLASS_MAP[status][pendingStatus][userPerms] = ''
      BLANK_ACREAGE_VALUES[status][pendingStatus][userPerms] = { numFields: 0, acreage: 0 }
    }
  }
}

FSS_YES_NO_CLASS_MAP[OPEN][STATUS_IS_STATIC][REGULAR_USER] = 'disabled submitted-no'
FSS_YES_NO_CLASS_MAP[OPEN][STATUS_IS_STATIC][STAFF_USER] = 'disabled submitted-no'
FSS_YES_NO_CLASS_MAP[OPEN][STATUS_CHANGE_PENDING][REGULAR_USER] = 'disabled pending-yes'
FSS_YES_NO_CLASS_MAP[OPEN][STATUS_CHANGE_PENDING][STAFF_USER] = 'disabled pending-yes'

FSS_YES_NO_CLASS_MAP[AVAILABLE][STATUS_IS_STATIC][REGULAR_USER] = 'submitted-no'
FSS_YES_NO_CLASS_MAP[AVAILABLE][STATUS_IS_STATIC][STAFF_USER] = 'submitted-no'
FSS_YES_NO_CLASS_MAP[AVAILABLE][STATUS_CHANGE_PENDING][REGULAR_USER] = 'pending-yes'
FSS_YES_NO_CLASS_MAP[AVAILABLE][STATUS_CHANGE_PENDING][STAFF_USER] = 'pending-yes'

// pre-requested is a requested fss awaiting traceability, so the toggle reads/behaves like requested:
// yes is already submitted, and flipping to no is a pending un-request (back to available)
FSS_YES_NO_CLASS_MAP[REQUESTED_PENDING][STATUS_IS_STATIC][REGULAR_USER] = 'submitted-yes'
FSS_YES_NO_CLASS_MAP[REQUESTED_PENDING][STATUS_IS_STATIC][STAFF_USER] = 'submitted-yes'
FSS_YES_NO_CLASS_MAP[REQUESTED_PENDING][STATUS_CHANGE_PENDING][REGULAR_USER] = 'pending-no'
FSS_YES_NO_CLASS_MAP[REQUESTED_PENDING][STATUS_CHANGE_PENDING][STAFF_USER] = 'pending-no'

FSS_YES_NO_CLASS_MAP[REQUESTED][STATUS_IS_STATIC][REGULAR_USER] = 'submitted-yes'
FSS_YES_NO_CLASS_MAP[REQUESTED][STATUS_IS_STATIC][STAFF_USER] = 'submitted-yes'
FSS_YES_NO_CLASS_MAP[REQUESTED][STATUS_CHANGE_PENDING][REGULAR_USER] = 'pending-no'
FSS_YES_NO_CLASS_MAP[REQUESTED][STATUS_CHANGE_PENDING][STAFF_USER] = 'pending-no'

FSS_YES_NO_CLASS_MAP[CONFIRMED][STATUS_IS_STATIC][REGULAR_USER] = 'submitted-yes disabled'
FSS_YES_NO_CLASS_MAP[CONFIRMED][STATUS_IS_STATIC][STAFF_USER] = 'submitted-yes'
FSS_YES_NO_CLASS_MAP[CONFIRMED][STATUS_CHANGE_PENDING][REGULAR_USER] = 'pending-no disabled'
FSS_YES_NO_CLASS_MAP[CONFIRMED][STATUS_CHANGE_PENDING][STAFF_USER] = 'pending-no'

FSS_YES_NO_CLASS_MAP[LOCKED_FOR_PAYMENT][STATUS_IS_STATIC][REGULAR_USER] = 'submitted-yes disabled'
FSS_YES_NO_CLASS_MAP[LOCKED_FOR_PAYMENT][STATUS_IS_STATIC][STAFF_USER] = 'submitted-yes disabled'
FSS_YES_NO_CLASS_MAP[LOCKED_FOR_PAYMENT][STATUS_CHANGE_PENDING][REGULAR_USER] = 'pending-no disabled'
FSS_YES_NO_CLASS_MAP[LOCKED_FOR_PAYMENT][STATUS_CHANGE_PENDING][STAFF_USER] = 'pending-no disabled'

export const STATUS_MAP = {}
STATUS_MAP[OPEN] = {
  text: "Open",
  color: "gray",
  chipClass: "chip-slate-accent"
}
STATUS_MAP[AVAILABLE] = {
  text: "Available",
  color: "gray",
  chipClass: "chip-neutral-accent"
}
STATUS_MAP[REQUESTED] = {
  text: "Requested",
  color: "green",
  chipClass: "chip-success-accent"
}
STATUS_MAP[REQUESTED_PENDING] = {
  text: "Pending Traceability",
  color: "green",
  chipClass: "chip-success-filled"
}
STATUS_MAP[CONFIRMED] = {
  text: "Confirmed",
  color: "confirmed-green",
  chipClass: "chip-primary-accent"
}
STATUS_MAP[LOCKED_FOR_PAYMENT] = {
  text: "Locked For Payment",
  color: "green",
  chipClass: "chip-warning-accent"
}

export const CONTRACT_STATUS_MAP = {}
CONTRACT_STATUS_MAP[NOT_READY_YET] = {
  text: "Not Ready Yet",
  color: "gray",
}
CONTRACT_STATUS_MAP[READY_FOR_GENERATION] = {
  text: "Ready For Generation",
  color: "gray",
}
CONTRACT_STATUS_MAP[CONTRACT_GENERATED] = {
  text: "Contract Generated",
  color: "gray",
}
CONTRACT_STATUS_MAP[AWAITING_REVIEW] = {
  text: "Awaiting Review",
  color: "amber",
}
CONTRACT_STATUS_MAP[CONTRACT_VOIDED] = {
  text: "Contract Voided",
  color: "red",
}
CONTRACT_STATUS_MAP[CHANGES_REQUESTED] = {
  text: "Changes Requested",
  color: "orange",
}
CONTRACT_STATUS_MAP[APPROVED] = {
  text: "Approved",
  color: "green",
}
CONTRACT_STATUS_MAP[CONTRACT_COMPLETED] = {
  text: "Contract Completed",
  color: "green",
}

export const PROCESSING_STATUS_MAP = {}
PROCESSING_STATUS_MAP["complete"] = {
  text: "complete",
  color: "confirmed-green",
  chipClass: "chip-primary-accent"
}
PROCESSING_STATUS_MAP["pending"] = {
  text: "pending",
  color: "orange",
}
PROCESSING_STATUS_MAP["error"] = {
  text: "error",
  color: "red",
}

export const CP_VIEW = 0
export const CSM_VIEW = 1

export const USER_CAN_COUNTERSIGN = [
  215, // Ariah - a.mazgajewski@arvaintelligence.com
  379, // Alexis - a.covington@arvaintelligence.com
  398, // Caroline - c.hollingsworth@arvaintelligence.com
  332, // April - a.tutor@arvaintelligence.com
  257, // Jonathan - j.hall@arvaintelligence.com
  506, // Carson - c.miller@arvaintelligence.com
  527, // Dylan S - d.sherfick@arvaintelligence.com
  489, // Andrew G. - a.greenwell@arvaintelligence.com
  224, // Emily B. - e.beddoe@arvaintelligence.com
  90, // Kyle W. - k.wilson@arvaintelligence.com
]

export const USER_CAN_VOID = [
  215, // Ariah - a.mazgajewski@arvaintelligence.com
  506, // Carson - c.miller@arvaintelligence.com
  398, // Caroline - c.hollingsworth@arvaintelligence.com
  548, // Andrew B. - a.baskin@arvaintelligence.com
  379, // Alexis - a.covington@arvaintelligence.com
]
